export const OPEN_COMPRESSOR_FORM = "OPEN_COMPRESSOR_FORM";
export const OPEN_CONVERTOR_FORM = "OPEN_CONVERTOR_FORM";